<title>{{ connectPage.htmlTitle }}</title>
<app-banner [banner]="connectPage.banner"></app-banner>
<div class="container">
  <div class="row" class="mt-20 mb-30">
    <div>
      <app-connect-card [connectCard]="connectPage.connectCard"></app-connect-card>
    </div>
  </div>
</div>
